import { makeStyles } from '@surveycake/rc';

export const useUnitStyles = makeStyles([
  [
    'unit',
    (theme, [isArrowShow]) => `
      :lang(ar){
        transform: scaleX(-1) translateY(-50%);
      }
      position: absolute;
      right: ${isArrowShow ? 20 : 0}px;
      top: 50%;
      transform: translateY(-50%);
      border-radius: 13px;
      border: 1px solid ${theme.survey.option.default.border.color};
      padding: 2px 8px;
      color: ${theme.color.primary.default};
      font-size: 14px;
    `
  ]
]);
